import {Card} from 'platform/components';

import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {QueryFilterObject} from 'features/eag-grid';

import {CommunicationActivityLogDatagrid} from '../CommunicationActivityLogDatagrid/CommunicationActivityLogDatagrid';
import type {DmsDataGridProps} from '../DmsDataGrid/DmsDataGrid';

interface CommunicationMessageHistoryProps
  extends RequiredTestIdProps,
    Pick<DmsDataGridProps, 'maximization'> {
  customerId: string;
  presetInstanceId: string;
}

export function CommunicationMessageHistory(props: CommunicationMessageHistoryProps) {
  const queryModifier = (filter: QueryFilterObject) => ({
    ...filter,
    customerId: [props.customerId],
    recordId: undefined,
  });

  return (
    <Card
      title={i18n.t('general.labels.emailActivityLogs')}
      isFullHeight
      key={props.presetInstanceId}
    >
      <CommunicationActivityLogDatagrid
        maximization={props.maximization}
        queryModifier={queryModifier}
        presetInstanceId={props.presetInstanceId}
        data-testid={props['data-testid']}
      />
    </Card>
  );
}
